import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Prompt } from '@src/suite/common/store/story/models/story.models';

export const StoryActions = createActionGroup({
    source: 'Story',
    events: {
        'Add mos item': props<{ storyId: string; mosStr: string; mosPluginId?: string }>(),
        'Replace mos item': props<{ storyId: string; mosElId: string; mosStr: string; mosPluginId?: string }>(),
    },
});

export const StoryHttpActions = createActionGroup({
    source: 'Story Http',
    events: {
        'Load Prompts': emptyProps(),
        'Load Prompts Success': props<{ data: any }>(),
        'Load Prompts Error': props<{ error: string }>(),
        'Generate New Version': props<{ prompt: Prompt; topic: StorytellingTopicRecord; openNewPrompt?: boolean }>(),
        'Create New Version Success': props<{ topic: StorytellingTopicRecord; generatedText: string; promptTitle: string; openNewPrompt?: boolean }>(),
        'Create New Version Error': props<{ error: string }>(),
        'Create Story Template': props<{ story: StorytellingStoryRecord; path: string }>(),
        'Release story lock': props<{ storyGuid: string }>(),
    },
});
